<template>
    <div class="d-flex flex-row max-content">
        <b-button :id="id"
                  class="text-left max-content d-flex flex-row position-relative"
                  :class="textInfo?'text-info':''"
                  :variant="warning?'warning': emptyToDefault(variant, 'light')"
                  :title="field.key"
                  @click="$emit('btnClick')">
            <template v-if="customBtn">
                <slot name="btn" :label="viewLabel"></slot>
            </template>
            <template v-else>
                {{ viewLabel }}
                <slot name="inBtn"></slot>
            </template>
            <div class="dot" v-if="hasCode(field.transform)"></div>
        </b-button>
        <template v-if="needAlias">
            <div class="as-cover"
                 :class="asRepeat?'text-danger':(asNoNeed||field.alias?'':'text-warning')">
                AS
            </div>
            <click-edit :value.sync="field.alias"
                        :default-value="field.key"></click-edit>
        </template>
        <b-popover v-if="withPopover" :target="id" triggers="hover" placement="right">
            <template #title>{{ viewLabel }}</template>
            <slot name="popover"></slot>
            <template v-if="allowCustomTransform">
                <b-form-input class="mt-1" v-model="field.transform" placeholder="Transform"></b-form-input>
            </template>
        </b-popover>
    </div>
</template>

<script>
import ClickEdit from "@/components/common/inputs/ClickEdit.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "FieldBtn",
    components: {ClickEdit},
    mixins: [emCommonUtilMixin],
    props: {
        field: Object,
        warning: {
            type: Boolean,
            default: false
        },
        variant: String,
        textInfo: {
            type: Boolean,
            default: false
        },
        needAlias: {
            type: Boolean,
            default: false
        },
        asNoNeed: {
            type: Boolean,
            default: false
        },
        asRepeat: {
            type: Boolean,
            default: false
        },
        withPopover: Boolean,
        customBtn: Boolean,
        allowCustomTransform: Boolean,
    },
    computed: {
        id() {
            return this.viewLabel + this.genNonDuplicateID(4);
        },
        viewLabel() {
            return `${this.field.target}.${this.field.label || this.field.key}`
        },
    }
}
</script>

<style scoped>
.max-content {
    width: max-content !important;
}

.as-cover {
    margin: auto .25rem !important;
}

.dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    position: absolute;
    top: -3px;
    right: -3px;
    background-color: #ffba2e;
}
</style>
